<script setup lang="ts">
import { StaticFile } from "~/classes/file/StaticFile"

const props = defineProps({
  creates: null
})

const { getFileReference } = useAgent()

/** Returns [file, loading, error] */
const fileWithFallback = (item: {
  request: FileCreateRequestDatagram
  response?: FileCreateResponseDatagram
}): [StaticFile, boolean, DatagramError | undefined] => {
  const reference = getFileReference(item.request.file.id)
  if (reference)
    return [reference, !item.response, item.response?.error]
  if (item.response?.file)
    return [new StaticFile(item.response.file), !item.response, item.response?.error]
  return [new StaticFile(item.request.file), !item.response, item.response?.error]
}

const files = computed(() => Array.from(props.creates.values()).map(fileWithFallback))
</script>

<template>
  <agent-status-files
    :files="files"
    :label="`Creating ${files.length} ${files.length === 1 ? 'file' : 'files'}`"
  />
</template>
